<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">DUK</li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>
        DUK (Daftar Urut Jabatan dan Kepangkatan) - Periode
        {{ commonFunction.formatDateMonthYear(tglDuk) }}
      </h5>
    </div>
    <LogPopupTemplate ref="logPopup" />

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <h5>Daftar prioritas penyusunan DUK:</h5>
        <ol>
          <li><strong>Jabatan</strong></li>
          <li>
            Jika jabatan sama, urutkan berdasarkan <strong>Golongan</strong>
          </li>
          <li>
            Jika golongan sama, urutkan berdasarkan
            <strong>TMT Golongan</strong>
          </li>
          <li>
            Jika tmt golongan sama, urutkan berdasarkan
            <strong>TMT Jabatan</strong>
          </li>
          <li>
            Jika tmt jabatan sama, urutkan berdasarkan
            <strong>Tanggal Mulai Bekerja</strong>
          </li>
          <li>
            Jika tanggal mulai bekerja sama, urutkan berdasarkan
            <strong>Masa Kerja</strong>
          </li>
          <li>
            Jika masa kerja sama, urutkan berdasarkan
            <strong>Pendidikan</strong>
          </li>
          <li>
            Jika Pendidikan sama, urutkan berdasarkan
            <strong>NIK --&gt; akan diatur ulang</strong>
          </li>
          <li>
            Terakhir urutkan berdasarkan
            <strong>Tanggal Lahir dan Tanggal Pensiun</strong>
          </li>
        </ol>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- absenStore.dataSourceAbsenList -->
        <!-- :data-source="" -->
        <DxDataGrid
          :focused-row-enabled="true"
          :focused-row-index="0"
          ref="dataGrid"
          :data-source="dukListStore.dataSourceDukList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="false"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />
          <DxToolbar>
            <DxItem location="before">
              <DxDateBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                :input-attr="{ 'aria-label': 'Periode DUK' }"
                display-format="MMMM yyyy"
                type="date"
                picker-type="calendar"
                :open-on-field-click="true"
                :calendar-options="{
                  maxZoomLevel: 'year',
                  minZoomLevel: 'year',
                }"
                label="Periode DUK"
                placeholder="Pilih Periode DUK"
                :value="tglDuk"
                @value-changed="onTglDukChanged"
              />

              <!-- @valueChanged="dukListStore.onTglChanged" -->
              <!-- -->
            </DxItem>

            <DxItem location="center">
              <DxSelectBox
                :items="[
                  { text: 'DUK Pegawai', value: true },
                  {
                    text: 'DUK Pegawai (Direksi, Tetap, Capeg, Honor, Kontrak)',
                    value: false,
                  },
                ]"
                display-expr="text"
                value-expr="value"
                v-model:value="checkboxValue"
                @value-changed="onPegawaiStatusChanged($event)"
                style="width: 320px; margin-right: 16px"
              />
            </DxItem>

            <DxItem location="after">
              <DxButton
                icon="print"
                @click="print()"
                text="Print"
                type="default"
                style="float: left"
                width="150px"
                styling-mode="filled"
              ></DxButton>
            </DxItem>
            <DxItem location="after">
              <DxButton
                icon="exportxlsx"
                @click="downloadFileExcel"
                text="Export"
                type="default"
                style="float: left"
                width="150px"
                styling-mode="filled"
              ></DxButton>
            </DxItem>

            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="true" />
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            data-type="number"
            caption="Opsi"
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="getOptions(data)"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <DxColumn
            caption="pegawaiID"
            data-field="id"
            data-type="number"
            :visible="false"
          />

          <DxColumn
            caption="No."
            data-field="duk"
            :allow-filtering="true"
            :allow-sorting="true"
            :allow-exporting="true"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <DxColumn
            data-field="nama"
            caption="Nama Pegawai"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :min-width="200"
          >
          </DxColumn>

          <DxColumn
            data-type="string"
            data-field="nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-type="string"
            data-field="jabatan_search"
            caption="Jabatan"
            :allowHeaderFiltering="false"
            cell-template="template-jabatan-print"
            :width="400"
          >
          </DxColumn>
          <DxColumn
            data-type="string"
            data-field="tmt_jabatan_search"
            caption="TMT Jabatan"
            :allowHeaderFiltering="false"
            cell-template="template-tmt-jabatan-print"
          >
          </DxColumn>

          <template #template-jabatan-print="{ data }">
            <div v-html="data.data.jabatan_print"></div>
          </template>

          <template #template-tmt-jabatan-print="{ data }">
            <div v-html="data.data.tmt_jabatan_print"></div>
          </template>

          <DxColumn
            data-type="string"
            data-field="golongan_nama"
            caption="Gol"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="tmt_golongan"
            caption="TMT Tgl Gol"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />

          <DxColumn
            data-field="tgl_mulai_bekerja"
            caption="Tgl Mulai Bekerja"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />

          <DxColumn
            caption="Masa Kerja Thn"
            data-field="masa_kerja_tahun"
            data-type="number"
          />

          <DxColumn
            caption="Masa Kerja Bln"
            data-field="masa_kerja_bulan"
            data-type="number"
          />

          <DxColumn
            data-type="string"
            data-field="pendidikan"
            caption="Pendidikan"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-type="string"
            data-field="diklat_search"
            caption="Pelatihan/Latihan Jabatan/Kompetensi"
            :width="300"
            :allowHeaderFiltering="true"
            :allowSearch="true"
            cell-template="template-diklat"
          >
          </DxColumn>

          <template #template-diklat="{ data }">
            <div v-html="data.data.diklat_print"></div>
          </template>

          <DxColumn
            data-field="tgl_lahir"
            caption="Tgl Lahir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />

          <DxColumn
            data-field="pensiun_tgl"
            caption="Pensiun U 56"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* Custom styles for selected rows in dxDataGrid */
.focused-grid .dx-datagrid .dx-selection {
  background-color: rgba(119, 199, 231, 0.8) !important; /* Green background */
  color: white !important; /* White text */
}

/* Custom styles for focused rows in dxDataGrid */
.focused-grid .dx-datagrid .dx-row-focused {
  background-color: #2196f3 !important; /* Blue background for focused row */
  color: white !important; /* White text */
}
</style>
<script>
import DxSelectBox from "devextreme-vue/select-box";
import { useAbsenStore } from "@/stores/views/absen-store";
import { useDukListStore } from "@/stores/views/duk-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import { DateTime } from "luxon";
// import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import * as commonFunction from "@/utils/common-function.js";
import { ref } from "vue";
import * as XLSX from "xlsx";
import LogPopupTemplate from "./LogPopupTemplate.vue";
// import { on } from "devextreme/events";

/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    DxSelectBox,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
  },
  setup() {
    const checkboxValue = ref(true);
    const dukListStore = useDukListStore();
    const absenStore = useAbsenStore();
    const commonStore = useCommonStore();
    const tglDuk = ref(DateTime.now().set({ day: 1 }).toISODate());
    const onTglDukChanged = (e) => {
      tglDuk.value = e.value;

      dukListStore.setFilter([
        ["tgl", "=", tglDuk.value],
        ["capeg_tetap", "=", checkboxValue.value],
        ["include_direksi", "=", !checkboxValue.value],
        ["definitif", "=", false],
      ]);
    };

    const onPegawaiStatusChanged = (e) => {
      dukListStore.setFilter([
        ["tgl", "=", tglDuk.value],
        ["capeg_tetap", "=", checkboxValue.value],
        ["include_direksi", "=", !checkboxValue.value],
        ["definitif", "=", false],
      ]);
    };

    return {
      checkboxValue,
      onPegawaiStatusChanged,
      onTglDukChanged,
      tglDuk,
      commonFunction,
      dukListStore,
      commonStore,
      absenStore,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      // checkboxValue: true,
      filterOperations: ["=", "<>", ">", "<", "between"],
      filterValue: [],

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,

      calculateFilterExpressionUmur: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        var colFilter = "tgl_lahir";
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let filterExpression = [];
          if (filterValue == 0) {
            filterExpression.push([colFilter, "=", null]);
          } else {
            filterExpression.push(
              [colFilter, "<=", vm.calculateDateFromAge(filterValue)],
              "and",
              [
                colFilter,
                ">",
                vm.calculateDateFromAge(parseInt(filterValue) + 1),
              ],
            );
          }
          return filterExpression;
        }

        if (selectedFilterOperation === ">" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            "<",
            vm.calculateDateFromAge(parseInt(filterValue) + 1),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            "<>",
            vm.calculateDateFromAge(parseInt(filterValue)),
          ];
          return filterExpression;
        }

        if (selectedFilterOperation === "<" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            ">",
            vm.calculateDateFromAge(filterValue),
          ];
          return filterExpression;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          if (typeof filterValue === "string") {
            let coba = filterValue
              .split(",")
              .map((part) => Number(part.trim()));

            filterValue = coba;
          }
          const minAge = filterValue[0];
          const maxAge = filterValue[1];
          if (minAge !== undefined && maxAge !== undefined) {
            return [
              [colFilter, ">", vm.calculateDateFromAge(parseInt(maxAge) + 1)], // Using '<' to include the exact date of birth
              "and",
              [colFilter, "<", vm.calculateDateFromAge(minAge)],
            ];
          } else if (minAge !== undefined) {
            return [colFilter, "<", vm.calculateDateFromAge(minAge)];
          } else if (maxAge !== undefined) {
            return [
              colFilter,
              ">",
              vm.calculateDateFromAge(parseInt(maxAge) + 1),
            ];
          } else {
            return null; // Return null to indicate that no filter should be applied
          }
        }
      },
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  mounted() {},

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    getOptions(data) {
      return [
        {
          text: "Detail Pegawai",
          pegawai_id: data.data.id,
        },
        {
          text: "Absensi",
          pegawai_id: data.data.id,
        },
        {
          text: "Riwayat Gaji",
          pegawai_id: data.data.id,
        },
        {
          text: "Log Perubahan Data",
          pegawai_id: data.data.id,
        },
        // other options...
      ];
    },

    async downloadFileExcel() {
      const pejabat = await this.commonFunction.getPejabatPengesahan(
        this.tglDuk,
      );

      // const dataDuk = await this.dukListStore.getData([
      //   "tgl",
      //   "=",
      //   this.tglDuk,
      // ]);

      const dataDuk = await this.dukListStore.getData([
        ["tgl", "=", this.tglDuk],
        ["capeg_tetap", "=", this.checkboxValue],
        ["include_direksi", "=", !this.checkboxValue],
        ["definitif", "=", false],
      ]);

      const duks = dataDuk.data;

      const workbook = XLSX.utils.book_new();
      const sheetName = this.commonFunction
        .formatDateMonthYear(this.tglDuk)
        .toUpperCase();
      XLSX.utils.book_append_sheet(workbook, {}, sheetName);
      const ws = workbook.Sheets[sheetName];
      let numbering = 1;
      let row = 1;
      this.wbAoa(
        ws,
        "DAFTAR URUT JABATAN DAN KEPANGKATAN PEGAWAI PERUMDA AIR MINUM TIRTA HITA BULELENG",
        "B" + row,
      );
      row += 1;
      this.wbAoa(ws, "PER " + sheetName, "B" + row);
      row += 2;
      this.wbAoa(ws, "NO", "B" + row);
      this.wbAoa(ws, "NAMA", "C" + row);
      this.wbAoa(ws, "NIK", "D" + row);
      this.wbAoa(ws, "JABATAN", "E" + row);
      this.wbAoa(ws, "TMT", "F" + row);
      this.wbAoa(ws, "GOL", "G" + row);
      this.wbAoa(ws, "TMT", "H" + row);
      this.wbAoa(ws, "TANGGAL", "I" + row);
      this.wbAoa(ws, "MASA", "J" + row);
      this.wbAoa(ws, "PENDI", "L" + row);
      this.wbAoa(ws, "PELATIHAN", "M" + row);
      this.wbAoa(ws, "TANGGAL", "N" + row);
      this.wbAoa(ws, "PENSIUN", "O" + row);
      row += 1;
      this.wbAoa(ws, "JABATAN", "F" + row);
      this.wbAoa(ws, "TANGGAL", "H" + row);
      this.wbAoa(ws, "MULAI BEKERJA", "I" + row);
      this.wbAoa(ws, "KERJA", "J" + row);
      this.wbAoa(ws, "DIKAN", "L" + row);
      this.wbAoa(ws, "YANG PERNAH DIIKUTI/", "M" + row);
      this.wbAoa(ws, "LAHIR", "N" + row);
      this.wbAoa(ws, "U 56", "O" + row);
      row += 1;
      this.wbAoa(ws, "GOL", "H" + row);
      this.wbAoa(ws, "THN", "J" + row);
      this.wbAoa(ws, "BLN", "K" + row);
      this.wbAoa(ws, "LATIHAN JABATAN/KOMPTENSI", "M" + row);
      row += 1;
      this.wbAoa(ws, "1", "B" + row);
      this.wbAoa(ws, "2", "C" + row);
      this.wbAoa(ws, "3", "D" + row);
      this.wbAoa(ws, "4", "E" + row);
      this.wbAoa(ws, "5", "F" + row);
      this.wbAoa(ws, "6", "G" + row);
      this.wbAoa(ws, "7", "H" + row);
      this.wbAoa(ws, "8", "I" + row);
      this.wbAoa(ws, "9", "J" + row);
      this.wbAoa(ws, "10", "L" + row);
      this.wbAoa(ws, "11", "M" + row);
      this.wbAoa(ws, "12", "N" + row);
      this.wbAoa(ws, "13", "O" + row);

      row += 2;
      let firstOfDukRow = row;
      let rowLengthInDUK = 0;
      let splitTemp = null;
      duks.forEach((duk) => {
        row += 1;
        rowLengthInDUK = 0;
        firstOfDukRow = row; //jangan diubah, karena menjadi acuan
        this.wbAoa(ws, numbering++, "B" + row); // NO
        this.wbAoa(ws, duk.nama.toUpperCase(), "C" + row); // NAMA
        this.wbAoa(ws, duk.nik, "D" + row); // NIK
        splitTemp = duk.jabatan_search.split(",");
        splitTemp.forEach((jabatan, index) => {
          this.wbAoa(ws, jabatan.trim(), "E" + (row + index)); // JABATAN
        });
        rowLengthInDUK = splitTemp.length; // Get the length of jabatan_search split

        splitTemp = duk.tmt_jabatan_search.split(",");
        splitTemp.forEach((jabatan, index) => {
          this.wbAoa(ws, jabatan.trim(), "F" + (row + index)); // JABATAN
        });

        this.wbAoa(ws, duk.golongan_nama, "G" + row); // GOL
        this.wbAoa(
          ws,
          this.commonFunction.formatDateDMY(duk.tmt_golongan),
          "H" + row,
        ); // TMT GOL
        this.wbAoa(
          ws,
          this.commonFunction.formatDateDMY(duk.tgl_mulai_bekerja),
          "I" + row,
        ); // TGL MULAI BEKERJA
        this.wbAoa(ws, duk.masa_kerja_tahun, "J" + row); // MASA KERJA THN
        this.wbAoa(ws, duk.masa_kerja_bulan, "K" + row); // MASA KERJA BLN
        this.wbAoa(ws, duk.pendidikan, "L" + row); // PENDIDIKAN
        splitTemp = duk.diklat_search.split(",");
        splitTemp.forEach((jabatan, index) => {
          this.wbAoa(ws, jabatan.trim(), "M" + (row + index)); // JABATAN
        });

        if (splitTemp.length > rowLengthInDUK) {
          rowLengthInDUK = splitTemp.length;
        }

        this.wbAoa(
          ws,
          this.commonFunction.formatDateDMY(duk.tgl_lahir),
          "N" + row,
        ); // TGL LAHIR
        this.wbAoa(
          ws,
          this.commonFunction.formatDateDMY(duk.pensiun_tgl),
          "O" + row,
        ); // PENSIUN U 56
        row += rowLengthInDUK - 1; // Set the row to the last row of jabatan
      });

      row += 3;

      this.wbAoa(ws, "Menyetujui:", "C" + row);
      this.wbAoa(ws, "Mengetahui:", "E" + row);
      this.wbAoa(ws, "Dibuat oleh:", "M" + row);
      row += 6;
      this.wbAoa(ws, pejabat.dirut.nama, "C" + row);
      this.wbAoa(ws, pejabat.dirum.nama, "E" + row);
      this.wbAoa(ws, pejabat.pejabatMengetahui.nama, "M" + row);
      row += 1;
      this.wbAoa(ws, "Direktur Utama", "C" + row);
      this.wbAoa(ws, "Direktur Umum", "E" + row);
      // this.wbAoa(ws, "Kepala Bagian Umum", "M" + row);
      this.wbAoa(ws, pejabat.pejabatMengetahui.jabatan, "M" + row);

      XLSX.writeFile(workbook, "DUK " + sheetName + ".xlsx");
    },
    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },

    print() {
      // let filterValue = ["tgl", "=", this.tglDuk];
      let filterValue = [
        ["tgl", "=", this.tglDuk],
        ["capeg_tetap", "=", this.checkboxValue],
      ];
      const encodedFilter = encodeURIComponent(JSON.stringify(filterValue));

      const url = this.$router.resolve({
        name: "duk-print",
        query: {
          filter: encodedFilter,
          tgl: this.tglDuk,
        },
      }).href;
      window.open(url, "_blank");
    },
    onContextMenuPreparing(e) {
      if (e.target == "content") {
        e.itemData = {
          pegawai_id: e.row.data.id,
        };

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            e.itemData.text = "Detail Pegawai";

            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData.text = "Absensi";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData.text = "Riwayat Gaji";
            this.onItemClick(e);
          },
        });
        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showBySubject(
              e.itemData.pegawai_id,
              "SimpegPegawai",
            );
          },
        });
      }
    },

    onItemClick(e) {
      let pegawaiId = e.itemData.pegawai_id;

      if (e.itemData.text === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: {
            filter: ["absen_bulans_pegawai_id", "=", pegawaiId],
          },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showBySubject(pegawaiId, "SimpegPegawai");
      }
    },

    addPegawaiBaru() {
      this.$router.push({
        name: "simpeg-pegawai-add",
      });
    },
    transformUrlToQuery(filterQueries) {
      const filters = Array.isArray(filterQueries)
        ? filterQueries
        : [filterQueries];

      // Check if 'and' or 'or' exists in filters
      const containsLogicalOperators = filters.some(
        (filter) => filter === "and" || filter === "or",
      );

      if (containsLogicalOperators) {
        // If 'and' or 'or' is found, proceed with transformation
        const transformedFilters = this.transformFilters(filters);

        // Use the transformed filters in your component logic
        return transformedFilters;
      } else {
        // Handle cases where no logical operator is present
        return filterQueries;
      }
    },
    transformFilters(filters) {
      // Initialize an empty array to hold the transformed filters
      const transformedFilters = [];

      // Iterate over the filters to transform them
      filters.forEach((filter) => {
        // Check if the filter is 'and' or 'or'
        if (filter === "and" || filter === "or") {
          transformedFilters.push(filter);
        } else {
          // Split the filter string into its components
          const filterParts = filter.split(",");
          transformedFilters.push(filterParts);
        }
      });

      return transformedFilters;
    },
    refreshDatagrid(gridRef) {
      this.dukListStore.dataSourceDukList.filter(null);
      // this.absenStore.dataSourceAbsenList.filter(null);
      if (this.$refs[gridRef] && this.$refs[gridRef].instance) {
        // this.$refs[gridRef].instance.clearFilter();
        this.$refs[gridRef].instance.getDataSource().reload();
      }
    },
    calculateDateFromAge(age) {
      const today = DateTime.local();
      return today.minus({ years: age }).toJSDate();
    },
    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },

    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Daftar Pegawai");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pegawai.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
